import React from 'react';
import { MapPin, Phone, Facebook, Clock, Mail } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-8" data-testid="contact-page-title">
          Contactez-nous
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Contact Info */}
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Informations de contact</h2>

              <div className="space-y-6">
                {/* Address */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-gray-900 font-semibold mb-1">Adresse</h3>
                    <p className="text-gray-500">
                      N°13 Lotissement Mohamed Essadik Benyahia<br />
                      Dar El Beïda, Alger, Algérie
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-gray-900 font-semibold mb-1">Téléphone</h3>
                    <a href="tel:+213552108488" className="text-gray-500 hover:text-cyan-400 transition">
                      +213 552 10 84 88
                    </a>
                  </div>
                </div>

                {/* Facebook */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Facebook className="w-6 h-6 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-gray-900 font-semibold mb-1">Facebook</h3>
                    <a 
                      href="https://www.facebook.com/share/1FQC6R4eFw/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-gray-500 hover:text-cyan-400 transition"
                    >
                      Facebook GC Store
                    </a>
                  </div>
                </div>

                {/* Instagram */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-cyan-400" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-gray-900 font-semibold mb-1">Instagram</h3>
                    <a 
                      href="https://www.instagram.com/gcstoredz?igsh=aDNkdGltdW1pZmU=" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-gray-500 hover:text-cyan-400 transition"
                    >
                      @gcstoredz
                    </a>
                  </div>
                </div>

                {/* Hours */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-gray-900 font-semibold mb-1">Horaires d'ouverture</h3>
                    <div className="text-gray-500 space-y-1">
                      <p>Samedi - Jeudi: 9h00 - 18h00</p>
                      <p>Vendredi: Fermé</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* About */}
            <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">À propos de GC STORE</h2>
              <p className="text-gray-500 mb-4">
                GC STORE est votre destination gaming de confiance à Dar El Beïda. 
                Nous sommes spécialisés dans la vente d'équipements gaming, 
                de matériel informatique et d'accessoires de qualité.
              </p>
              <p className="text-gray-500">
                Notre équipe de passionnés est là pour vous conseiller et vous aider 
                à trouver les meilleurs produits pour votre setup gaming.
              </p>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden h-[600px] flex items-center justify-center">
            <div className="text-center p-8">
              <MapPin className="w-16 h-16 text-cyan-400 mx-auto mb-4" />
              <h3 className="text-gray-900 font-bold text-xl mb-2">Visitez-nous en magasin</h3>
              <p className="text-gray-500 mb-4">
                N°13 Lotissement Mohamed Essadik Benyahia<br />
                Dar El Beïda, Alger
              </p>
              <a
                href="https://www.google.com/maps/search/?api=1&query=N13+Lotissement+Mohamed+Essadik+Benyahia+Dar+El+Beida+Algeria"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-cyan-500 text-white font-semibold px-6 py-3 rounded-lg hover:bg-cyan-600 transition"
              >
                Ouvrir dans Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
